"use client";
import React, { useState } from "react";
import Heading from "./ui/Heading";
import FAQItem from "./ui/FAQItem";
import Schema from "./Schema";

interface FAQ {
  question: string;
  answer: string;
}

interface BrandFAQProps {
  faqs: FAQ[];
  showContainer?: boolean;
  containerClassName?: string;
  heading?: string;
  headingTag?: "h1" | "h2" | "h3" | "h4" | "h5" | "h6";
  headingClassName?: string;
  expendTrackingClass?:string;
  collapseTrackingClass?:string;
}

const BrandFAQ: React.FC<BrandFAQProps> = ({
  faqs,
  showContainer = false,
  containerClassName = "container mx-auto px-4 sm:px-6 lg:px-8",
  heading,
  headingTag,
  headingClassName,
  expendTrackingClass = '',
  collapseTrackingClass = ''
}) => {
  const [openIndex, setOpenIndex] = useState<number>(0);

  const handleToggle = (index: number) => {
    setOpenIndex(prev => (prev === index ? -1 : index));
  };

  const faqSchema = faqs && faqs.length > 0 ? {
    '@context': 'https://schema.org',
    '@type': 'FAQPage',
    mainEntity: faqs.map((faq) => ({
      '@type': 'Question',
      name: faq.question,
      acceptedAnswer: {
        '@type': 'Answer',
        text: faq.answer,
      },
    })),
  } : null;

  if (!faqs || faqs?.length === 0) return null;

  const Content = (
    <>
      <Schema schema={faqSchema} />
      {heading && (
        <Heading tag={headingTag ?? "h2"} className={headingClassName ?? "mb-4"}>
          {heading}
        </Heading>
      )}
      <div>
        {faqs.map((faq, index) => (
          <FAQItem
            key={index}
            question={faq.question}
            answer={faq.answer}
            index={index}
            isOpen={openIndex === index}
            onToggle={() => handleToggle(index)}
            expendTrackingClass={expendTrackingClass}
            collapseTrackingClass={collapseTrackingClass}
          />
        ))}
      </div>
    </>
  );

  return (
    <section className="mt-4 md:mt-8">
      {showContainer ? (
        <div className={containerClassName}>{Content}</div>
      ) : (
        Content
      )}
    </section>
  );
};

export default BrandFAQ;